<template>
  <div class="mobile_container">
    <div class="top">
      <mt-search
        v-model="Search"
        :result.sync="searchResult"
        cancel-text="取消"
        placeholder="搜索">
      </mt-search>
    </div>

    <div class="content">
      <div class="group">
        <p>最常查看设备</p>
        <ul>
          <li :class="{active: 0}">
            <p>草莓大棚北门温度计温度计2222</p>
            <div :class="{active: 0}">

            </div>
          </li>
          <li>
            <p>温度计</p>
          </li>
          <li>
            <p>温度计</p>
          </li>
          <li>
            <p>温度计</p>
          </li>
        </ul>
      </div>
      <div class="group">
        <p>草莓大棚北门</p>
        <ul>
          <li>
            <p>草莓大棚北门温度计温度计</p>
          </li>
          <li>
            <p>温度计</p>
          </li>
          <li>
            <p>温度计</p>
          </li>
          <li>
            <p>温度计</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config.js'

  export default {
    name: 'commonDevice',
    components: {},
    data() {
      return {
        Search: "",
        searchResult: ['视频设备', '传感器', '控制器'],
      }
    },
    mounted: function () {
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  .mint-search {
    height: 100%;
  }
  .mint-search-list-warp {
    position: relative;
    z-index: 20;
  }

  div.mobile_container {
    div.content {
      div.group {
        p {
          font-size: 0.28rem;
          color: rgba(0, 0, 0, 0.65);
          letter-spacing: 0;
          text-align: left;
          font-weight: 700;
          padding: 0.15rem 0.26rem;
        }
        ul {
          overflow: hidden;
          padding: 0.15rem 0.26rem;
          text-align: center;
          li {
            display: flex;
            align-items: center;
            position: relative;
            float: left;
            margin-right: 0.14rem;
            margin-bottom: 0.16rem;
            background: #f2f2f2;
            border-radius: 0.08rem;
            width: 1.81rem;
            height: 0.82rem;
            &.active {
              background: #eaf7f0;
            }
            p {
              /*border: solid 1px red;*/
              overflow: hidden;
              padding: 0.1rem 0.1rem;
              text-align: center;
              width: 100%;
              font-size: 0.26rem;
              color: rgba(0, 0, 0, 0.65);
              letter-spacing: 0;
              text-align: center;
              font-weight: 400;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            div {
              display: none;
            }
            div.active {
              display: block;
              width:23px;
              height:37px;
              position: absolute;
              top: 0.2rem;
              left: 1.51rem;
              background:#23c7a9;
              border-radius:8px;


            }
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/commonDevice.vue